export function shareVK(url: string): void {
  const width = 600;
  const height = 400;
  const left = window.innerWidth / 2 - width / 2;
  const top = window.innerHeight / 2 - height / 2;
  window.open(`https://vk.com/share.php?url=${url}`, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
}

export function shareFB(url: string): void {
  const width = 600;
  const height = 400;
  const left = window.innerWidth / 2 - width / 2;
  const top = window.innerHeight / 2 - height / 2;
  window.open(`https://www.facebook.com/dialog/share?app_id=164936710911531&display=popup&href=${url}`, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
}

export const copyToClipboard = str => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};
